import React from "react";
import imperial_tobacco from "../../../assets/img/john_player_ignite_col_logo.png";

import "./logos.css";

const Logos = () => {
  return (
    <div className="row brands">
      <img
        className="imperial-logo"
        src={imperial_tobacco}
        title="Imperial Brands"
        alt="Imperial Brands"
      />
    </div>
  );
};

export default Logos;



// WEBPACK FOOTER //
// ./src/components/layout/empty/logos.jsx